import React from 'react';
import "../Css/ContactPage.css";
import { FaHome } from 'react-icons/fa';
import { IoIosArrowForward } from 'react-icons/io';
import { Button, Form, Input } from 'antd';
// import TextArea from 'antd/es/input/TextArea';
import Footer from "../Component/Footer/Footer";
import $ from "jquery";

const ContactPage = () => {
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const handleSubmit = (values) => {
        var body = '<!DOCTYPE html><html><head><title>Enquiry Lead</title></head><body><div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;background-color:#000;padding:20px"><h2 style="color:#fff">WOODSY</h2><p style="color:#fff">Hello</p><p style="color:#fff">Thank you for your interest in our products/services.</p><p style="color:#fff">Please check your enquiry which generated from website:</p><table cellpadding="5" style="margin:0"><tr><td style="text-align:left;color:#fff"><strong>Name:</strong></td><td style="text-align:left;color:#fff">' + values.name + '</td></tr><tr><td style="text-align:left;color:#fff"><strong style="color:#fff">Mail:</strong></td><td style="text-align:left;color:#fff">' + values.email + '</td></tr><tr><td style="text-align:left;color:#fff"><strong>Contact No:</strong></td><td style="text-align:left;color:#fff">' + values.contact + '</td></tr><tr><td style="text-align:left;color:#fff"><strong>Message:</strong></td><td style="text-align:left;color:#fff">' + values.message + '</td></tr></table><p style="text-align:left;color:#fff">Best regards,<br>Your Team at Woodsy</p></div></body></html>';


        $.post(
            "https://skdm.in/server/v1/send_lead_mail.php",
            {
                toEmail: "daddu.tamhankar01@gmail.com",
                fromEmail: "darveshzakia81@gmail.com",
                bccMail: "skdmlead@gmail.com",
                mailSubject: "New Customer Lead",
                mailBody: body,
                accountName: "1Five",
                accountLeadSource: "https://woodsy.co.in/",
                accountLeadName: values.name,
                accountLeadEmail: values.email,
                accountLeadPhone: values.contact,
            },
            function (dataa, status) {
                console.log('data:', dataa);
            }
        );

        alert("Your Form has Submitted. Our team will contact you soon.");

        // Reset the form fields after submission
        form.resetFields();
    };

    return (
        <div>
            {/* Banner Section */}
            <section className='contact-section-banner'>
                <div className='container'>
                    <div className='contact-section-banner-main-con'>
                        <div className='contact-section-banner-con'>
                            <h2>contact us</h2>
                            <div className='contact-section-banner-content'>
                                <FaHome />
                                <IoIosArrowForward />
                                <span>contact us</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Info Section */}
            <section className='contact-page-section-2'>
                <div className='container'>
                    <div className='contact-page-section-out-body-main-con'>
                        <div className='contact-page-section-out-body-con'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className='contact-page-card-main-con'>
                                        <div className="address-text first">
                                            <div className="icon"><i className="mdi mdi-map-marker"></i></div>
                                            <div className="content">
                                                <div className="address-label">Address:</div>
                                                <a href='https://maps.app.goo.gl/1dkvj6Q2SVkZoerK8' target='blank'>
                                                Global lumbers Gala no 48 Sant Savta Marg Mustufa bazaar, opposite Usha Godown, <br />Byculla East, Mumbai, Maharashtra 400010
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='contact-page-card-main-con'>
                                        <div className="address-text second">
                                            <div className="icon"><i className="mdi mdi-phone-classic"></i></div>
                                            <div className="content">
                                                <div className="address-label">Contact Numbers:</div>
                                                <div>
                                                    <a href="tel:+919833553720" target='blank'>
                                                        +91 76666 66555
                                                    </a>
                                                </div>
                                                <div>
                                                    <a href="tel:+917666666555" target='blank'>
                                                        +91 98335 53720
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='contact-page-card-main-con'>
                                        <div className="address-text third">
                                            <div className="icon"><i className="mdi mdi-email"></i></div>
                                            <div className="content">
                                                <div className="address-label">Email:</div>
                                                <a href="mailto:darveshzakia81@gmail.com">darveshzakia81@gmail.com</a>
                                                <p>&nbsp;</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Form + Map Section */}
            <section className='contact-page-section-3'>
                <div className='container'>
                    <div className='contact-page-section-3-main-con'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='contac-page-section-form-main-con'>
                                    <Form form={form} onFinish={handleSubmit}>
                                        <div className='contact-form-main-con'>
                                            <Form.Item name="name" rules={[{ required: true, message: 'Please enter your name' }]}>
                                                <Input placeholder='Name' />
                                            </Form.Item>
                                        </div>
                                        <div className='contact-form-main-con'>
                                            <Form.Item name="email" rules={[{ required: true, message: 'Please enter your email' }]}>
                                                <Input placeholder='Email' />
                                            </Form.Item>
                                        </div>
                                        <div className='contact-form-main-con'>
                                            <Form.Item name="contact" rules={[{ required: true, message: 'Please enter your phone number' }]}>
                                                <Input placeholder='Phone Number' />
                                            </Form.Item>
                                        </div>
                                        <div className='contact-form-main-con'>
                                            <Form.Item name="message" rules={[{ required: true, message: 'Please enter your message' }]}>
                                            <TextArea placeholder="Message" rows={10} />
                                            </Form.Item>
                                        </div>
                                        <div className='contact-form-btn'>
                                            <Button htmlType='submit' type='primary'>
                                                Send
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='contact-page-map-main-con'>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.988402172582!2d72.8388313!3d18.976119599999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cfb5fe994af1%3A0x4f822394d144cbdc!2sWoodsy!5e0!3m2!1sen!2sin!4v1747739685398!5m2!1sen!2sin"
                                        width="100%" height="100%" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade">
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default ContactPage;
